import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {ObjectFactory} from "@commons/types";
import {merge} from "lodash";

export type TipoAbilitazione = "DISABILITATA" | "ABILITATA" | "ABILITATA_X_COMPENSAZIONE";
export type RegolaQuantificazione = "SINGOLA_TIMBRATURA" | "COPPIA_TIMBRATURE" | "INTERA_GIORNATA";

export interface QuantificaEccRecord extends URIAndTrace {
    idAzienda: number,
    idAziendaTabelle: number,
    idTable: number,
    descrizione: string,
    idTabella: number,
    tempoMax: number,
    tempoMinimo: number,
    multipliDi: number,
    tempoBonus: number,
    compensa: boolean,
    tempoMinimoEntrata: number,
    tempoMaxEntrata: number,
    multipliDiEntrata: number,
    tempoBonusEntrata: number,
    tipoAbilitazione: TipoAbilitazione,
    regola: RegolaQuantificazione,
}

export class QuantificaEccRecord {
    static factory: ObjectFactory<QuantificaEccRecord> = (json?) => {

        return merge<QuantificaEccRecord, Partial<QuantificaEccRecord> | undefined>({
            idAzienda: 0,
            idAziendaTabelle: 0,
            idTable: 0,
            descrizione: '',
            idTabella: 0,
            tempoMax: 0,
            tempoMinimo: 0,
            multipliDi: 0,
            tempoBonus: 0,
            compensa: false,
            tempoMinimoEntrata: 0,
            tempoMaxEntrata: 0,
            multipliDiEntrata: 0,
            tempoBonusEntrata: 0,
            tipoAbilitazione: 'DISABILITATA',
            regola: 'SINGOLA_TIMBRATURA',
            URI: null,
        }, json);
    }

}